module.exports = __webpack_public_path__ + "static/media/GDPR_form.78c2dd00.odt";